/* eslint-disable semi */
<template>
  <div>
    <el-table
      v-bind:data="displayOrderedSchedule"
      :show-header="false"
      row-key="id"
      @row-click="expandRow"
      :expand-row-keys="expand"
      :row-class-name="getRowName"
      empty-text="No events scheduled"
      style="width: 100%"
    >
      <!-- Expandable message history list -->
      <el-table-column type="expand">
        <template slot-scope="scope">
          <MessageTimeline
            :patient="patient"
            :schedule="scope.row"
            v-bind:edit="edit"
          >
          </MessageTimeline>
        </template>
      </el-table-column>

      <el-table-column fixed="left" width="50">
        <template slot-scope="scope">
          <div style="margin-top: 10px;">
            <img
              v-if="expand.length && expand[0] === scope.row.id"
              src="../../images/up-arrow.png"
              width="21px"
              height="21px"
            />
            <img
              v-else
              src="../../images/down-arrow.png"
              width="21px"
              height="21px"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="time" width="110">
        <template slot-scope="scope">
          <div class="col-flex-dir">
            <span class="row-date dt-tm">{{ formatDate(scope.row.time) }}</span>
            <span class="row-time dt-tm" v-if="scope.row.time % 1000 !== 123">{{ formatTime(scope.row.time) }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="title" width="300" class-name="schedule-cell">
        <template slot-scope="scope">
          <!-- add event category here-->
          <strong>
            {{ getEventName(scope.row.event) || scope.row.event_name }}
          </strong>
          <div class="schedule-info" v-if="allPatientsChosen">
            <span>
              {{ getProviderNameById(scope.row.provider.split(":")[0]) }}
            </span>
            <span v-if="getUserType !== 'observer'">
              &middot;
              {{ getContentKey("profile", scope.row.profile, "title") }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column class-name="" width="80">
        <template slot-scope="scope">
          <div style="position: relative" v-if="getUnansweredSurveyCount(scope.row.message)">
            <img src="./icon/survey.svg">
            <div class="unanswered-survey-count-icon">
              <span>{{ getUnansweredSurveyCount(scope.row.message) }}</span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="title" class-name="answered-cell">
        <template slot-scope="scope">
          <template
            v-if="
              answeredQuestionnaires[scope.row.id] ===
                getAllQuestionaniresCount[scope.row.id] &&
                answeredQuestionnaires[scope.row.id]
            "
          >
            <span class="all-answered-text"
              ><b
                >{{ answeredQuestionnaires[scope.row.id] }} of
                {{ getAllQuestionaniresCount[scope.row.id] }}</b
              >
              questionnaire{{
                getAllQuestionaniresCount[scope.row.id] > 1 ? "s" : ""
              }}
              answered</span
            >
          </template>
          <template v-else-if="getAllQuestionaniresCount[scope.row.id]">
            <span class="answer-count-text">
              <b
                >{{ answeredQuestionnaires[scope.row.id] }} of
                {{ getAllQuestionaniresCount[scope.row.id] }}</b
              >
              questionnaire{{
                getAllQuestionaniresCount[scope.row.id] > 1 ? "s" : ""
              }}
              answered&nbsp;
            </span>
            <template v-if="getUserType !== 'observer'">
              <el-button
                type="text"
                size="small"
                class="send-now"
                @click="openSendNowModal(scope.row.id, $event)"
              >
                Remind now
              </el-button>
              <p v-if="scope.row.reminder" class="reminder-stamp">
                Last - {{ getReminderTimeStamp(scope.row.reminder) }}
              </p>
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="title" v-if="getUserType !== 'observer'">
        <template slot-scope="scope">
          <MessageStatus :patient="patient" :schedule="scope.row">
          </MessageStatus>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        width="130"
        v-if="getUserType !== 'observer'"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            style="text-decoration: underline"
            v-bind:disabled="scheduling"
            @click="editSchedule(scope.row, $event)"
          >
            EDIT
          </el-button>
          &nbsp;&nbsp;&nbsp;&bull;
          <el-button
            type="text"
            size="small"
            @click="removeSchedule(scope.row, $event)"
          >
            <span style="color:red; text-decoration: underline">REMOVE</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="show-more" v-if="showRows < orderedSchedule.length">
      <el-button type="text" @click="showMore">
        {{ showMoreText }}&nbsp;<i class="el-icon-arrow-down"></i>
      </el-button>
    </div>

    <el-dialog
      :visible.sync="showSendNowModal"
      :append-to-body="true"
      class="send-now-modal"
      :before-close="finishSendingReminder"
      width="410px"
      :close-on-click-modal="false"
    >
      <span slot="title">Send Questionnaires</span>
      <template v-if="!reminderSent">
        <p>Send to</p>
        <br />
        <el-row>
          <el-col :span="5" type="flex">
            <el-checkbox v-model="sendEmail" class="checkbox"
              >Email</el-checkbox
            >
          </el-col>
          <el-col :span="19">
            <input
              placeholder="johndoe@gmail.com"
              v-model="patientEmail"
              :disabled="!sendEmail"
              :style="
                sendEmail && triedOnceEmailFlag && !validEmail(patientEmail)
                  ? 'border: solid 1px #da4e4e'
                  : ''
              "
            />
            <span
              v-if="
                sendEmail && triedOnceEmailFlag && !validEmail(patientEmail)
              "
              class="error-text"
            >
              Please enter valid email address
            </span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="5">
            <el-checkbox v-model="sendSMS" class="checkbox">SMS</el-checkbox>
          </el-col>
          <el-col :span="19">
            <input
              placeholder="(123) 456-7890"
              v-model="patientPhone"
              :disabled="!sendSMS"
              :style="
                sendSMS && triedOncePhoneFlag && !validPhone(patientPhone)
                  ? 'border: solid 1px #da4e4e'
                  : ''
              "
            />
            <span
              v-if="sendSMS && triedOncePhoneFlag && !validPhone(patientPhone)"
              class="error-text"
            >
              Please enter valid mobile number
            </span>
          </el-col>
        </el-row>

        <span
          v-if="!sendSMS && !sendEmail"
          style="margin-top: 10px;"
          class="error-text"
          >{{ errorText }}</span
        >

        <div class="footer">
          <LoadingButton
            type="primary"
            size="small"
            class="send-button"
            @click="sendReminder"
            :loading="isSendingReminder"
            :loaded="reminderSent"
          >
            Send
          </LoadingButton>
          <el-button
            type="text"
            size="small"
            class="cancel-button"
            @click="finishSendingReminder"
          >
            Cancel
          </el-button>
        </div>
      </template>
      <div v-else class="send-succcess">
        <TickIcon></TickIcon>
        <span v-if="errorText.length">{{ errorText }}</span>
        <span v-else-if="sendEmail && !sendSMS">Email sent successfully!</span>
        <span v-else-if="sendEmail && sendSMS"
          >Email and SMS sent successfully!</span
        >
        <span v-else-if="!sendEmail && sendSMS">SMS sent successfully!</span>
        <div class="footer">
          <el-button
            type="primary"
            size="small"
            style="margin-left: 15px;"
            @click="finishSendingReminder"
            >Done</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="editTitle"
      :visible.sync="showEdit"
      :append-to-body="true"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="margin-top:-20px;text-align:center;">
        <el-date-picker
          ref="edit"
          v-model="editTime"
          type="date"
          format="MMM d, yyyy"
          range-separator="/"
          placeholder="Select new date"
        >
        </el-date-picker>
        &nbsp;&nbsp;
        <el-button @click="sendEditSchedule" type="primary"
          >Edit Event</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import formatDate from "@/module/util/format-date";
import formatDateTime from "@/module/util/format-date-time";
import formatTime from '@/module/util/format-time'

import MessageTimeline from "./message/Timeline";
import MessageStatus from "./message/Status";

import TickIcon from "../../icon/Tick";
import validEmail from "@/module/util/valid-email";
import validPhone from "@/module/util/valid-phone";

import LoadingButton from "@/module/component/LoadingButton";

const CELL_STYLE = {
  date: {
    color: "#5f5f5f",
    fontWeight: "700",
  },
  title: {
    fontWeight: "500",
  },
};

export default {
  name: "patient-schedule-card-table",

  props: {
    patient: {
      type: Object,
      required: true,
    },
  },

  watch: {
    /**
     * Resetting the flag for SMS that signifies if the send button has been clicked or not.
     */
    sendSMS: function() {
      if (!this.sendSMS) {
        this.triedOncePhoneFlag = false;
      }
    },
    /**
     * Resetting the flag for email that signifies if the send button has been clicked or not.
     */
    sendEmail: function() {
      if (!this.sendEmail) {
        this.triedOnceEmailFlag = false;
      }
    },
  },

  data() {
    return {
      edit: null,
      editTime: null,
      showEdit: false,
      showRows: 3,
      showLess: false,
      expand: [],
      showSendNowModal: false,
      sendEmail: !!this.patient.email,
      sendSMS: !!this.patient.phone,
      patientEmail: this.patient.email,
      patientPhone: this.patient.phone,
      currentReminderId: null,
      answeredQuestionnaires: {},
      reminderSent: false,
      errorText: "",
      isSendingReminder: false,
      /**
       * Flag that signifies if reminder has been tried to be sent once via SMS
       * Used for showing error only after send has been clicked at least once.
       */
      triedOncePhoneFlag: false,
      /**
       * Flag that signifies if reminder has been tried to be sent once via Email
       * Used for showing error only after send has been clicked at least once.
       */
      triedOnceEmailFlag: false,
    };
  },

  mounted() {
    if (this.schedule) this.fillDefaultAnswerCount();
  },

  methods: {
    ...mapActions("provider", [
      "updatePatientSchedule",
      "removePatientSchedule",
      "createPatientReminder",
    ]),
    validEmail,
    validPhone,
    formatDate,
    formatDateTime,
    formatTime,
    /**
     * Gets unanswered survey count for the provided event id
     */
    getUnansweredSurveyCount(message) {
      if(!this.patient.survey) return 0
      let count = 0
      message.forEach(m => {
        count += this.patient.survey.filter(survey => survey.message.includes(m) && !survey.completed).length
      })
      return count
    },
    /**
     * Hides the modal
     * and sets reminderSent value to default
     */
    finishSendingReminder() {
      this.errorText = "";
      this.showSendNowModal = false;
      this.triedOncePhoneFlag = false;
      this.triedOnceEmailFlag = false;
      this.reminderSent = false;
    },
    /**
     * Fills the default count for number of
     * questionnaires answered for every event to 0
     */
    fillDefaultAnswerCount() {
      this.schedule.forEach((schedule) => {
        this.answeredQuestionnaires[schedule.id] = 0;
      });
    },
    /**
     * Checks if email and phone number are valid
     * and at least one is selected or not
     * @returns { Boolean } Is valid or not
     */
    isValid() {
      this.errorText = "";
      if (!this.sendEmail && !this.sendSMS) {
        this.errorText = "At least one of the above mode should be selected";
        return false;
      } else if (this.sendEmail && !this.validEmail(this.patientEmail))
        return false;
      else if (this.sendSMS && !this.validPhone(this.patientPhone))
        return false;
      return true;
    },
    /**
     * Makes the reminder object and
     * sends the reminder using currentReminderId
     */
    sendReminder() {
      this.triedOncePhoneFlag = true;
      this.triedOnceEmailFlag = true;
      if (!this.isValid()) return;
      this.isSendingReminder = true;
      let reminder = {};
      reminder.id = this.currentReminderId;
      reminder.patient = this.patient.id;
      if (!this.getCurrentProvider) {
        const schedule = this.displayOrderedSchedule.find(
          ({ id }) => id === this.currentReminderId
        );
        if (schedule && schedule.provider)
          reminder.provider = schedule.provider.split(":")[0];
      }

      if (this.sendEmail) reminder.email = this.patientEmail;
      if (this.sendSMS) reminder.phone = this.patientPhone;

      this.createPatientReminder(reminder)
        .then((res) => {
          this.isSendingReminder = false;
          this.reminderSent = true;
          if (res.code === "NoPendingQuestionnaire")
            this.errorText = "No pending questionnaires";
          else this.errorText = "";

          // assign current time to current patient's reminder
          this.patient.reminder = this.getReminderTimeStamp();
        })
        .catch((err) => {
          this.isSendingReminder = false;
          this.errorText = "Error sending reminder";
          if (err.hasOwnProperty("code")) this.errorText = err.code;
          console.log("Error sending reminder", err);
        });
    },
    /**
     * Open the Modal for sending reminder.
     */
    openSendNowModal(id, e) {
      e.stopPropagation();
      this.showSendNowModal = true;
      this.currentReminderId = id;
    },
    expandRow(row, a, b) {
      if (this.expand[0] == row.id) this.expand = [];
      else this.expand = [row.id];
    },
    showMore() {
      this.showLess = true;
      this.showRows += 10;
    },
    showLessHandler() {
      this.showLess = false;
      this.showRows = 3;
    },
    editSchedule(schedule, e) {
      e.stopPropagation();
      this.editTime = schedule.time;
      this.edit = schedule;
      this.showEdit = true;

      setTimeout(() => {
        this.$refs.edit.focus();
      }, 300);
    },
    sendEditSchedule() {
      if (this.editTime == null || this.scheduling) return;

      var time = new Date(this.editTime).setHours(12);
      time -= new Date().getTimezoneOffset() * 60000;

      this.updatePatientSchedule({
        patient: this.patient.id,
        id: this.edit.id,
        time,
        provider: this.edit.provider.split(":")[0],
      }).then(() => {
        this.edit = null;
        this.editTime = null;
        this.showEdit = false;
      });
    },
    removeSchedule(schedule, e) {
      e.stopPropagation();

      this.$confirm(
        "This will permanently delete <strong>" +
          this.getEventName(schedule.event) +
          "</strong> on <strong>" +
          this.formatDate(schedule.time, true) +
          "</strong> from " +
          this.patient.name +
          "'s appointment schedule.",
        "Are you sure?",
        {
          confirmButtonText: "Delete event",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--danger",
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false
        }
      )
        .then(() => {
          return this.removePatientSchedule({
            patient: this.patient.id,
            id: schedule.id,
            provider: schedule.provider.split(":")[0],
          });
        })
        .catch((error) => {
          console.log(error);
          // canceled
        });
    },
    /**
     * Get answered/completed questionnaire
     *
     * @param {String} refEvent Id of the Event
     * @returns {Number} Number of completed questionnaires
     */
    getAnsweredQuestionnaires(refEvent) {
      return this.getPatientEvents(this.patient.id)
        .filter((e) => e.message === refEvent || e.id === refEvent)
        .filter((e) => e.hasOwnProperty("completed")).length;
    },
    getReminderTimeStamp(date) {
      if (date) {
        return this.formatDateTime(new Date(date));
      }
      return this.formatDateTime(new Date());
    },
    getRowName(rowData) {
      return rowData.row ? rowData.row.id : rowData.rowIndex
    }
  },

  computed: {
    ...mapGetters("content", ["getContent", "getContentKey"]),
    ...mapGetters("provider", [
      "getCurrentProvider",
      "allPatientsChosen",
      "getProviderNameById",
      "getPatientEvents",
      "getPatientSchedule",
      "getPatientLoadingState",
      "getPatientMessage",
      "getPatientSchedulingState",
      "getProvidersIdArray",
    ]),
    ...mapGetters(["getUserType"]),
    /**
     * Get the total number of questionnaires
     * from schedule_event in patient object
     *
     * Gets message id from patient.schedule_event
     * Maps the message id with store message object and gets ref_event
     * Maps the ref_event ids with store event object
     * and gets the key "message" and gets final event id
     * Gets the event objects from store and checks for "completed" key
     *
     *
     * @returns {Number} Total number of questionnaires.
     */
    getAllQuestionaniresCount() {
      let totalQuestionnaires = {};
      this.schedule.forEach((schedule) => {
        let total = 0;
        let count = 0;
        schedule.message.forEach((messageId) => {
          let messageObj = this.getPatientMessage(this.patient.id, messageId);
          if (messageObj && messageObj.hasOwnProperty("ref_event")) {
            let refEvents = [];
            if (Array.isArray(messageObj.ref_type)) {
              messageObj.ref_type.forEach((refType, index) => {
                if (refType === "questionnaire")
                  refEvents.push(messageObj.ref_event[index]);
              });
            } else if (
              messageObj.hasOwnProperty("attachment") &&
              messageObj.attachment.length > 0
            ) {
              messageObj.attachment.forEach((attachment) => {
                if (
                  attachment.ref_type === "questionnaire" &&
                  attachment.ref_event &&
                  !attachment.survey
                ) {
                  refEvents.push(attachment.ref_event);
                }
              });
            } else if (
              typeof messageObj.ref_event === "string" &&
              messageObj.ref_type === "questionnaire"
            )
              refEvents = [messageObj.ref_event];

            total += refEvents.length;
            refEvents.forEach(
              (refEvent) => (count += this.getAnsweredQuestionnaires(refEvent))
            );
          } else if (
            messageObj &&
            messageObj.hasOwnProperty("status") &&
            messageObj.status === "sent" &&
            messageObj.ref_type === "questionnaire"
          ) {
            total += 1;
          }
        });
        totalQuestionnaires[schedule.id] = total;
        this.answeredQuestionnaires[schedule.id] = count;
      });
      return totalQuestionnaires;
    },
    showMoreText() {
      return "Show more";
    },
    showLessText() {
      return "Show less";
    },
    getEventName() {
      return (id) => {
        let event = this.getContent("event", id);
        if (event) return event.name;
      };
    },
    schedule() {
      return this.getPatientSchedule(this.patient.id);
    },
    orderedSchedule() {
      if (this.schedule)
        return this.schedule
          .slice()
          .sort((a, b) => b.time - a.time)
          .filter((schedule) => {
            if (this.allPatientsChosen)
              return this.getProvidersIdArray.includes(
                schedule.provider.split(":")[0]
              );
            else return schedule.provider.includes(this.getCurrentProvider);
          });
      return [];
    },
    displayOrderedSchedule() {
      if (this.orderedSchedule)
        return this.orderedSchedule.slice(0, this.showRows);
      return [];
    },
    loading() {
      return this.getPatientLoadingState(this.patient.id);
    },
    scheduling() {
      return this.getPatientSchedulingState(this.patient.id);
    },
    editTitle() {
      if (this.edit)
        return "Edit date of " + this.getEventName(this.edit.event);
      return "";
    },
  },

  components: {
    MessageTimeline,
    MessageStatus,
    TickIcon,
    LoadingButton,
  },
};
</script>

<style lang="scss" scoped>
@import "@/module/app/theme/color.scss";

.show-more {
  .el-button {
    display: block;
    width: 100%;
    font-size: 14px;
    color: #4a9bf9;
    font-weight: 600;
  }
  .el-icon-arrow-down {
    font-weight: 700;
  }
}

.answer-count-text {
  font-size: 12px;
  color: #666666;
  line-height: 12px;
}

.all-answered-text {
  font-size: 12px;
  color: #44b358;
}

.send-now,
.send-now:hover {
  font-size: 12px;
  font-weight: 700;
  color: #833e93;
  text-decoration: underline;
  display: block;
  padding: 0;
  padding-top: 5px;
}
.reminder-stamp {
  color: #666666;
  font-size: 10px;
  font-weight: 500;
}
.schedule-info {
  font-size: 12px;
  color: $grey-700;
}

.send-now-modal {
  margin-top: 70px;
  p {
    color: #333333;
  }
  .error-text {
    color: #da4e4e;
    margin-top: 5px;
    display: block;
    font-size: 12px;
  }
  .send-succcess {
    position: relative;
    span {
      position: absolute;
      top: 5px;
      left: 30px;
    }
  }
  .el-row {
    margin-top: 10px;
    .checkbox {
      margin-top: 5px;
      color: #333333;
    }
    input {
      width: 100%;
      height: 28px;
      border-radius: 0;
      border: solid 1px #cccccc;
      padding-left: 10px;

      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.36;
      letter-spacing: 1px;
      color: #333333;
    }
    input:focus {
      outline: none;
      border: solid 1px #2d3e4f;
    }
    input::placeholder {
      color: #dddddd;
      font-weight: 400;
    }
  }
  .footer {
    display: block;
    height: 20px;
    margin-top: 20px;
    .send-button {
      margin-left: 10px;
      width: 66px;
      height: 35px;
      padding: 5px;
      border-radius: 0;
    }
    .el-button {
      float: right;
      font-size: 14px;
    }
    .cancel-button {
      text-decoration: underline;
      color: #333333;
    }
  }
}

.col-flex-dir {
	display: inline-flex;
	flex-direction: column;
  width: 100%;

	.dt-tm {
		width: 100%;
		text-align: left;
	}

  .row-date {
    color: #333333;
  }
  .row-time {
    color: #666666;
  }
}
</style>

<style lang="scss">
@import "@/module/app/theme/color.scss";

.el-table .el-table__row {
  cursor: pointer;
}

.el-table__expand-icon {
  display: none;
}

.unanswered-survey-count-icon {
    position: absolute;
    top: -1px;
    right: -5px;
    height: 16px;
    width: 16px;
    background: #DA4E4E;
    border-radius: 50%;
    color: #ffffff;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    border: 1px solid white;
    span {
      position: absolute;
      top: -3px;
      right: 4px;
    }
}

.send-now-modal {
  .el-dialog__header {
    background-color: $primary-color;
    color: $white-color;
    padding: 11px 20px;
    font-size: 14px;
    line-height: 17px;
    font-weight: 500;
  }
  .el-dialog__headerbtn {
    top: 8px;
    right: 12px;
    font-size: 20px;
    .el-dialog__close {
      color: $white-color;
      font-weight: bold;
    }
    .el-dialog__close:hover {
      color: $white-color;
    }
  }
  .el-dialog__headerbtn:hover .el-dialog__close {
    color: $white-color;
  }
  .el-dialog__body {
    padding-top: 12px;
  }
}
.show-more {
  .el-button, .el-button:hover, .el-button:focus {
    display: block;
    width: 100%;
    font-size: 14px;
    color: #4a9bf9;
    font-weight: 600;
  }
  .el-icon-arrow-down {
    font-weight: 700;
  }
}
td.schedule-cell > div.cell {
  flex-direction: column;
  align-items: flex-start;
  word-break: break-word;
}
td.answered-cell > div.cell {
  flex-direction: column;
  align-items: flex-start;
  word-break: break-word;
}
td.schedule-cell > div.cell {
  flex-direction: column;
  align-items: flex-start;
  word-break: break-word;
}
td.answered-cell > div.cell {
  flex-direction: column;
  align-items: flex-start;
  word-break: break-word;
}
</style>
